export default __webpack_public_path__ + "static/media/13.4683dcc5.jpg";